
import Vue from 'vue';
import Component, { mixins } from 'vue-class-component';

@Component({
  name: 'video-not-availabble',
  props: ['type', 'code'],
})
export default class VideoNotAvailable extends Vue {
  private type;
  private code;

  get descText() {
    if (this.code == 'mau_limit_exceeded') {
      return this.$t('player.videos.mau_limit_exceeded');
    } else if (this.type == 'link') {
      return this.$t('player.videos.link_deleted');
    }
    return this.$t('player.videos.deleted');
  }

  get faType() {
    if (this.type == 'link') {
      return 'unlink';
    } else {
      return 'video-slash';
    }
  }
}
